import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from './supabaseClient.js';

export default function CreatorPage() {
  const { nombre } = useParams();
  const navigate = useNavigate();
  const [creator, setCreator] = useState(null);
  const [nubbis, setNubbis] = useState([]);

  useEffect(() => {
    const fetchCreator = async () => {
      const { data, error } = await supabase
        .from('creadores')
        .select('nombre_completo, avatar_url')
        .ilike('url', nombre)
        .single();

      if (!error) setCreator(data);
    };

    const fetchNubbis = async () => {
      const { data, error } = await supabase
        .from('characters')
        .select('id, name, image')
        .eq('creador_url', nombre)
        .order('created_at', { ascending: true });

      if (!error) setNubbis(data);
    };

    fetchCreator();
    fetchNubbis();
  }, [nombre]);

  if (!creator) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center text-white text-2xl font-bold">
        Loading Creator...
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-500 to-purple-600 text-white py-16 px-4">
      {/* Botones de regreso */}
      <div className="flex justify-between max-w-7xl mx-auto mb-6 px-2">
        <button
          onClick={() => navigate('/creadores-v2')}
          className="bg-white text-blue-600 font-bold py-2 px-4 rounded-lg shadow-md hover:bg-blue-100 transition"
        >
          ← Back to Creators
        </button>
        <button
          onClick={() => navigate('/')}
          className="bg-white text-purple-600 font-bold py-2 px-4 rounded-lg shadow-md hover:bg-purple-100 transition"
        >
          🏠 Back to Nubbi
        </button>
      </div>

      <div className="flex flex-col items-center mb-12">
        <div className="mb-4">
          <img 
            src={creator.avatar_url ?? '/default_avatar.png'}
            alt={creator.nombre_completo}
            className="rounded-full w-40 h-40 object-cover border-4 border-white shadow-xl"
          />
        </div>
        <h1 className="text-4xl font-extrabold drop-shadow-lg">{creator.nombre_completo}</h1>
        <p className="text-lg font-semibold text-yellow-300 mt-2">{nubbis.length} Nubbis Created</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
        {nubbis.map((nubbi) => (
          <div key={nubbi.id} className="bg-white bg-opacity-10 rounded-2xl p-4 text-center shadow-lg hover:scale-105 transition cursor-pointer">
            <img 
              src={nubbi.image ?? '/fallback.png'}
              alt={nubbi.name}
              className="rounded-xl w-full mb-4 shadow-lg"
            />
            <h2 className="text-xl font-bold">{nubbi.name}</h2>
          </div>
        ))}
      </div>
    </div>
  );
}
